
import { AddMachineAnonymousNote } from './addMachineAnonymousNote';
import { Box, Typography, Menu, MenuItem } from '@mui/material';
import useResponsive from '../../../hooks/useResponsive';
import { useTranslation } from 'react-i18next';
import MachineStatus from '../machineStatus';
import MachineType from '../machineType';
import Iconify from '../../Iconify';
import { useState } from 'react';
import '../../../css/machines/machineDetailsHeader.css';

const PublicMachineDetailsHeader = ({ machine }) => {

    const { t } = useTranslation();
    const isDesktop = useResponsive('up', 'lg');

    const [openAddNote, setOpenAddNote] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openActionMenu = Boolean(anchorEl);

    const handleOpenActionMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseActionMenu = () => {
        setAnchorEl(null);
    };

    return (
        <Box className="MachineDetailsHeader_mainBox">
            <Box className="MachineDetailsHeader_firstPart">
                <Typography className="MachineDetailsHeader_title">{machine?.name}</Typography>
                {machine?.archive_reason && <Typography className="MachineDetailsHeader_archive_reason">({t(machine?.archive_reason)})</Typography>}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <MachineStatus status={machine?.status} />
                    <MachineType type={machine?.type} />
                </Box>
            </Box>
            <Box className="MachineDetailsHeader_secondPart">
                {isDesktop && !machine?.is_archived &&
                    <Box className="MachineDetailsHeader_action_box" onClick={() => setOpenAddNote(true)}>
                        <Iconify className='MachineDetailsHeader_copy_icon' icon="simple-line-icons:note" />
                        <Typography className="MachineDetailsHeader_copy_title">{t('Remarque')}</Typography>
                    </Box>
                }

                {!isDesktop && !machine?.is_archived &&
                    <Iconify
                        className='MachineDetailsHeader_dots_icon'
                        icon="vaadin:ellipsis-dots-v"
                        id="userPageActionMenuIcom"
                        aria-controls={openActionMenu ? 'long-menu' : undefined}
                        aria-expanded={openActionMenu ? 'true' : undefined}
                        aria-haspopup="true"
                        onClick={handleOpenActionMenu}
                    />
                }
                <Menu
                    id="usersePageActionMenu"
                    MenuListProps="usersPageActionMenuIcom"
                    open={openActionMenu}
                    anchorEl={anchorEl}
                    onClose={handleCloseActionMenu}
                    onClick={handleCloseActionMenu}
                    slotProps={{ paper: { style: { width: '30ch', backgroundColor: '#fffff' } } }}
                >
                    <MenuItem className='MachineDetailsHeader_menuItem' onClick={() => setOpenAddNote(true)}>
                        <Iconify className='MachineDetailsHeader_copy_icon' icon="simple-line-icons:note" />
                        <Typography className="MachineDetailsHeader_copy_title">{t('Remarque')}</Typography>
                    </MenuItem>
                </Menu>
            </Box>

            {openAddNote &&
                <AddMachineAnonymousNote
                    openAddNote={openAddNote}
                    setOpenAddNote={setOpenAddNote}
                />
            }

        </Box>
    );
}

export default PublicMachineDetailsHeader;